/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    DISPATCH_PLANS_RECEIVE,
    DISPATCH_PLANS_REQUEST,
    DISPATCH_PLANS_REQUEST_SUCCESS,
    DISPATCH_PLANS_REQUEST_FAILURE,
    CURRENT_DISPATCH_RECEIVE,
} from 'state/action-types';

export const items = createReducer([], {
    [DISPATCH_PLANS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [DISPATCH_PLANS_REQUEST]: () => true,
    [DISPATCH_PLANS_REQUEST_SUCCESS]: () => false,
    [DISPATCH_PLANS_REQUEST_FAILURE]: () => false,
});


export const error = createReducer(false, {
    [DISPATCH_PLANS_REQUEST]: () => false,
    [DISPATCH_PLANS_REQUEST_SUCCESS]: () => false,
    [DISPATCH_PLANS_REQUEST_FAILURE]: () => true,
});


export default combineReducers({
    items,
    requesting,
    error
});
